import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["aria-label", "borderRadius", "children", "gap", "limit", "showPercentage", "size", "value", "variant"];
import styled from 'styled-components';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import { LayoutSpaceVertical } from '../Layout/LayoutSpaceVertical';
import { LayoutHorizontal } from '../Layout/LayoutHorizontal';
import { Heading } from '../Typography';
import { LayoutBox } from '../Layout/LayoutBox';
import { getOverLimit, getPercentage } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FULL_PERCENT = 100;
const sizeMap = {
  xs: '0.3125rem',
  sm: '0.5rem',
  md: '0.75rem',
  lg: '1rem'
};
const variantMap = {
  success: 'var(--layout-lib-gradient-success)',
  warning: 'var(--layout-lib-gradient-warning)',
  danger: 'var(--layout-lib-gradient-danger)',
  breeze: 'var(--layout-lib-gradient-breeze-medium)'
};
const StyledBar = styled(LayoutBox).withConfig({
  displayName: "ProgressBar__StyledBar",
  componentId: "sc-1cns61z-0"
})(["background:", ";transition:inline-size 0.3s ease-in-out;"], ({
  $variant
}) => variantMap[$variant]);
export const ProgressBar = _ref => {
  let {
      'aria-label': ariaLabel,
      borderRadius = 'border-radius',
      children,
      gap = 'space-xs',
      limit,
      showPercentage = false,
      size = 'lg',
      value,
      variant = 'success'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const percentage = getPercentage({
    value,
    limit
  });
  const isOverLimit = getOverLimit({
    value,
    limit
  });
  const displayPercentage = isOverLimit ? FULL_PERCENT : percentage;
  return /*#__PURE__*/_jsxs(LayoutSpaceVertical, Object.assign({}, rest, {
    gap: gap,
    children: [showPercentage ? /*#__PURE__*/_jsxs(LayoutHorizontal, {
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx(LayoutBox, {
        children: children
      }), /*#__PURE__*/_jsx(Heading, {
        as: "span",
        fontSize: "xs",
        children: /*#__PURE__*/_jsx(FormattedPercentage, {
          value: displayPercentage
        })
      })]
    }) : null, /*#__PURE__*/_jsx(LayoutBox, {
      background: "background-color",
      blockSize: sizeMap[size],
      borderRadius: borderRadius,
      children: /*#__PURE__*/_jsx(StyledBar, {
        $size: size,
        $variant: variant,
        "aria-label": ariaLabel,
        "aria-live": "polite",
        "aria-valuemax": limit,
        "aria-valuemin": 0,
        "aria-valuenow": displayPercentage,
        blockSize: "100%",
        borderRadius: borderRadius,
        inlineSize: `${displayPercentage}%`,
        role: "progressbar"
      })
    })]
  }));
};